import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import { generatePath, RouteE } from 'src/constants/pages.constants';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
// import { useScreenDetect } from 'src/hooks/useScreenDetect';
import { decodeHTMLEntities } from 'src/utils/html.utils';
import { useCardAssets } from 'src/features/common/collection/hooks/use-card-assets';
import { StyledAvatar, StyledAvatarWrapper, StyledCircle, StyledCollectionName, StyledCollectionVolume, StyledContentWrapper, StyledWrapper } from './top-collection-card.styles';
import { ITopCollectionCard } from './top-collection-card.types';

export const TopCollectionCard = ({ collection, copies, rankingPosition }: ITopCollectionCard) => {
    const { t } = useTranslation(['pages']);
    // const screenType = useScreenDetect();
    const assets = useCardAssets({ collection });

    // const totalVolume = data?.totalVolume ? `${currency}${makePriceFromCents(+data.totalVolume)}` : '0';

    const link = generatePath(RouteE.COLLECTION_VIEW, {
        id: collection.id
    });

    const totalVolume = copies ? `${copies} ${t('home.widgets.topCollections.nftsSold')}`: '0';

    // const isNegative = TEST_PERCENT <= 0;

    return (
        <Link href={link} prefetch={false}>
            <a>
                <StyledWrapper alignItems='center'>
                    <StyledAvatarWrapper>
                        <StyledAvatar
                            width={40}
                            height={40}
                            src={assets.avatar}
                            retinaSrc={assets.avatarRetina}
                            videoSrc={assets.videoAvatar}
                            retinaVideoSrc={assets.videoAvatarRetina}
                        />
                        <StyledCircle>{rankingPosition}</StyledCircle>
                    </StyledAvatarWrapper>
                    <StyledContentWrapper>
                        <StyledCollectionName
                            overflowLines={1}
                            variant='title'
                            altTitle={decodeHTMLEntities(collection.name)}
                            medium
                            color='text'
                        >
                            {decodeHTMLEntities(collection.name)}
                        </StyledCollectionName>
                        <FlexBox alignItems='center' justifyContent='space-between'>
                            <StyledCollectionVolume>
                                {t('home.widgets.topCollections.volume')}: <span>{totalVolume}</span>
                            </StyledCollectionVolume>
                            {/* {!screenType.sm && ( */}
                            {/*    <Typography */}
                            {/*        tag='div' */}
                            {/*        size='xs' */}
                            {/*        color={isNegative ? 'pink500' : 'green500'} */}
                            {/*    > */}
                            {/*        {isNegative ? `${TEST_PERCENT}%` : `+${TEST_PERCENT}%`} */}
                            {/*    </Typography> */}
                            {/* )} */}
                        </FlexBox>
                    </StyledContentWrapper>
                </StyledWrapper>
            </a>
        </Link>
    );
};